/*
 * Copyright (C) 2022 Hal Perkins.  All rights reserved.  Permission is
 * hereby granted to students registered for University of Washington
 * CSE 331 for use solely during Winter Quarter 2022 for purposes of
 * the course.  No other use, copying, distribution, or modification
 * is permitted without prior written consent. Copyrights for
 * third-party components of this work must be honored.  Instructors
 * interested in reusing these course materials should contact the
 * author.
 */

import React, { Component } from "react";

interface InfoBoxProps  {
    toggle(): void;
}

/**
 * A component that will render a line on the React Leaflet map of color from
 * point x1,y1 to x2,y2. This line will convert from the assignment's coordinate
 * system (where 0,0 is the top-left of the UW campus) to latitude and
 * longitude, which the React Leaflet map uses
 */
class InstructionsModal extends Component<InfoBoxProps, {}> {

    handleClick = () => {
        this.props.toggle();
    };

    render() {
        return (
            <div className="instructions-modal">
                <div className="instructions-modal-content">
                    <span className="close"
                          onClick={this.handleClick}>&times;
                    </span>
                    <h2>Campus Paths</h2>
                    <p> No longer are the days of sprinting across campus to get to class on time!
                        This will find the shortest path between two buildings
                        on the <a href="https://www.washington.edu/">University of Washington</a> campus.
                    </p>
                    <p> Simply select a start and an end building and then press <b>FIND PATH</b></p>
                    <p> Press <b>SHOW/HIDE BUILDINGS</b> to see or hide
                        all the building locations and names on the map
                    </p>
                    <p> To modify the path color, move the red (R), green (G), and/or blue (B) sliders
                    </p>
                </div>
            </div>
        );
    }
}

export default InstructionsModal;
